import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { supabase } from '../../supabaseClient';
import VerifiedBadge from '../shared/VerifiedBadge';

function UserNameDisplay({ userId }) {
  const [name, setName] = useState('');
  const [matricule, setMatricule] = useState(null);

  useEffect(() => {
    if (!userId) return;
    let mounted = true;
    async function fetchName() {
      try {
        const [{ data: admin }, { data: profile }] = await Promise.all([
          supabase
            .from('admin_Profile')
            .select('First_name, Last_name')
            .eq('user_id', userId)
            .maybeSingle(),
          supabase
            .from('profiles')
            .select('Matricule')
            .eq('id', userId)
            .maybeSingle(),
        ]);
        if (!mounted) return;
        if (admin) {
          setName(`${admin.First_name || ''} ${admin.Last_name || ''}`.trim());
        }
        setMatricule(profile?.Matricule || null);
      } catch (err) {
        setName('');
        setMatricule(null);
      }
    }
    fetchName();
    return () => { mounted = false; };
  }, [userId]);

  if (!name) return null;
  return (
    <span style={{ marginLeft: 10, fontWeight: 500, fontSize: 16, color: '#222', display: 'inline-flex', alignItems: 'center' }}>
      {name}
      <VerifiedBadge matricule={matricule} size={16} />
    </span>
  );
}

UserNameDisplay.propTypes = {
  userId: PropTypes.string,
};

export default UserNameDisplay;
